import { Button, Grid } from "@mui/material";
import React from "react";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import admissionCalendarService from "../../../services/admissionCalendarService";
import logger from "../../../services/logger";
import Add from "../../common/add";
import PagingAndSorting from "../../common/pagingAndSorting";
import AdmissionCalendarTable from "./admissionCalendarTable";

class AdmissionCalendars extends PagingAndSorting {
  state = {
    data: [],
    sortColumn: { path: "id", order: "asc" },
    page: 0,
    rowsPerPage: 10,
    confirmDialogOpen: false,
  };

  getAll = async () => {
    try {
      const { data } = await admissionCalendarService.getAll();
      this.setState({ data });
    } catch (ex) {
      logger.error(ex);
    }
  };

  onConfirmOk = async (id) => {
    try {
      await admissionCalendarService.deleteById(id);
      await this.getAll();
    } catch (ex) {
      logger.error(ex);
    }
  };

  componentDidMount() {
    this.getAll();
  }

  render() {
    const { sortColumn, data } = this.state;
    const { t } = this.props;
    return (
      <React.Fragment>
        <Grid container>
          <Grid container item sm={12} md={12} lg={12} direction="row-reverse">
            <Button variant="contained" color="secondary">
              <Link to={"admission-calendars/new"}>{t("New Config")}</Link>
            </Button>
            {/* <Add link={"admission-calendars/new"} title={t("New Config")}  /> */}
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12}>
            <AdmissionCalendarTable
              data={data}
              sortColumn={sortColumn}
              onSort={this.handleSort}
              onDelete={this.handleDelete}
            ></AdmissionCalendarTable>
          </Grid>
        </Grid>
        {this.renderDeleteConfirmDialog(
          "Delete Confirmation",
          "Are you sure you want to delete?"
        )}
      </React.Fragment>
    );
  }
}

export default withTranslation(["admissionCalendar"])(AdmissionCalendars);
